export default __webpack_public_path__ + "static/media/Hades-small.acfa140e.gif";